import React from "react";
import { Box, Typography, Icon, Stack, Button } from "@mui/material";
import ReportProblemOutlinedIcon from "@mui/icons-material/ReportProblemOutlined"; // A good default icon

/**
 * A reusable component to display an error message.
 *
 * @param {string} message - The main error message to display.
 * @param {string} [details] - Optional smaller text for more details.
 * @param {React.ReactNode} [icon] - An optional icon to display. Defaults to ReportProblemOutlinedIcon.
 * @param {React.ReactNode} [actions] - Optional action buttons, e.g., a retry button.
 */
const ErrorDisplay = ({
  message = "Something went wrong.",
  details,
  icon = <ReportProblemOutlinedIcon fontSize="inherit" />,
  actions,
}) => {
  return (
    <Box
      sx={{
        display: "flex",
        flexDirection: "column",
        alignItems: "center",
        justifyContent: "center",
        textAlign: "center",
        py: 8,
        px: 3,
        minHeight: "auto", // Ensures it takes up significant space
      }}
    >
      <Icon sx={{ fontSize: 80, color: "grey.400", mb: 2 }}>{icon}</Icon>

      <Typography variant="h6" fontWeight="600" gutterBottom>
        {message}
      </Typography>

      {details && (
        <Typography variant="body2" color="text.secondary">
          {details}
        </Typography>
      )}

      {actions && (
        <Stack direction="row" spacing={2} sx={{ mt: 3 }}>
          {actions}
        </Stack>
      )}
    </Box>
  );
};

export default ErrorDisplay;
